__turbopack_context__.v({
  "className": "montserrat_bb4d9b29-module__WRPsWW__className",
});
